var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('HomeTopCarousel'),_c('HomeProductPromote'),_c('HomeNews'),(_vm.first_touch)?_c('HomeVideo'):_vm._e(),_c('HomeSocial')],1)}
var staticRenderFns = []

export { render, staticRenderFns }